import { render, staticRenderFns } from "./VSquareAvatar.vue?vue&type=template&id=90d94a8e&"
import script from "./VSquareAvatar.vue?vue&type=script&lang=js&"
export * from "./VSquareAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports